import React from 'react';
import { useTranslation } from 'react-i18next';

import './Loading.scss';

interface ILoadingProps {
  showText: boolean;
  height?: string;
}

const Loading = (props: ILoadingProps) => {
  const { t } = useTranslation();

  return (
    <>
      <svg className="spinner-wrapper" style={{ height: props.height }} viewBox="0 0 50 50" data-testid="loading-spinner-wrapper">
        <circle cx="25" cy="25" r="20" fill="none" strokeWidth="4" className="spinner" />
      </svg>
      {props.showText ? <div className="spinner-text">{t('getting-your-squad')}</div> : <div></div>}
    </>
  );
};

export default Loading;
